// Coordinates which auto-firing overlay is allowed to mount on a
// given route. Multiple modal overlays competing for focus on the
// same render is the failure mode; this hook turns that into one
// declarative priority list.
//
// Usage:
//
//   const active = useOverlayQueue({
//     onboarding:        showOnboarding,
//     streak_milestone:  !!milestone,
//     chapter_complete:  !!chapterComplete,
//     first_run_tour:    !isFirstRunTourSeen(),
//     player_coach:      !isPlayerCoached(),
//   });
//
//   // Render the highest-priority overlay only:
//   {active === 'first_run_tour' && <FirstRunTour ... />}
//
// The priority order is intentionally explicit: gates first,
// celebratory beats second, orientation last. Manual overlays
// (AppGuide / WhatsNewSheet) are not in this queue because they
// only open on direct user action.

const DEFAULT_PRIORITY = [
  'onboarding',
  'streak_milestone',
  'chapter_complete',
  'first_run_tour',
  'player_coach',
];

export default function useOverlayQueue(candidates, priority = DEFAULT_PRIORITY) {
  for (const name of priority) {
    if (candidates[name]) return name;
  }
  return null;
}
